import { Button, LinkButton } from '@cian/ui-kit';
import * as React from 'react';

interface IConnectToProgramButtonProps {
  href?: string;
  onClick?: () => void;
}

export const ConnectToProgramButton: React.FC<IConnectToProgramButtonProps> = ({ href, onClick }) => {
  const Element = href ? LinkButton : Button;

  const extraProps = href
    ? {
        href,
        target: '_blank',
      }
    : {};

  return (
    <Element fullWidth={true} onClick={onClick} {...extraProps}>
      Присоединиться к программе
    </Element>
  );
};
